import { inviteToCrooglooFromTopBar} from './dashboard';

export function init(){
  document.getElementById("inviteBtn").onclick = inviteToCrooglooFromTopBar;
}
